import Types from "./Types";

export const EventTypesLoading = (payload) => ({
  type: Types.EVENT_TYPES_LOADING,
  payload,
});

export const GetEventTypesSuccess = (payload) => ({
  type: Types.GET_EVENT_TYPES_SUCCESS,
  payload,
});

export const GetScrollEventTypesSuccess = (payload) => ({
  type: Types.GET_SCROLL_EVENT_TYPES_SUCCESS,
  payload,
});

export const GetEventTypeDetailsSuccess = (payload) => ({
  type: Types.GET_EVENT_TYPE_DETAILS_SUCCESS,
  payload,
});

export const GetEventTypeServicesSuccess = (payload) => ({
  type: Types.GET_EVENT_TYPE_SERVICES_SUCCESS,
  payload,
});

export const GetAvailableEventServicesSuccess = (payload) => ({
  type: Types.GET_AVAILABLE_EVENT_SERVICES_SUCCESS,
  payload,
});
